import { render } from "./screenshotList.vue?vue&type=template&id=6816171d&scoped=true"
import script from "./screenshotList.vue?vue&type=script&lang=js"
export * from "./screenshotList.vue?vue&type=script&lang=js"

import "./screenshotList.vue?vue&type=style&index=0&id=6816171d&lang=scss&scoped=true"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6816171d"]])

export default __exports__